[
  {
    "name": "Rachel Barlet",
    "role": "Front end developer",
    "description": "They way doctors treat urinary tract infections may be wrong, and antibiotic resistance is growing",
    "path": "assets/images/home/team/rachel.png"
  },
  {
    "name": "Michael johnson",
    "role": "UI/UX designer",
    "description": "Treating customers with respect earns loyalty. Dig into marketing personas that reflect real people to gain the most ",
    "path": "assets/images/home/team/michel.png"
  },
  {
    "name": "Lisa Aniston",
    "role": "Team management",
    "description": "Treating customers with respect earns you loyalty. Dig into marketing personas that reflect real people to.",
    "path": "assets/images/home/team/lisa.png"
  },
  {
    "name": "David Schimmer",
    "role": "Web developer",
    "description": "They way doctors treat urinary tract infections may be wrong, and antibiotic resistance is growing",
    "path": "assets/images/home/team/david.png"
  },
  {
    "name": "Rachel Barlet",
    "role": "Front end developer",
    "description": "They way doctors treat urinary tract infections may be wrong, and antibiotic resistance is growing",
    "path": "assets/images/home/team/rachel.png"
  },
  {
    "name": "Michael johnson",
    "role": "UI/UX designer",
    "description": "Treating customers with respect earns loyalty. Dig into marketing personas that reflect real people to gain the most ",
    "path": "assets/images/home/team/michel.png"
  },
  {
    "name": "Lisa Aniston",
    "role": "Team management",
    "description": "Treating customers with respect earns you loyalty. Dig into marketing personas that reflect real people to.",
    "path": "assets/images/home/team/lisa.png"
  },
  {
    "name": "David Schimmer",
    "role": "Web developer",
    "description": "They way doctors treat urinary tract infections may be wrong, and antibiotic resistance is growing",
    "path": "assets/images/home/team/david.png"
  }
]
